import service from '@/api/newsletter/sender';
import {handleError} from '@/state/generators/helpers';

export const state = {
    item: {},
    service: service('newsletters/senders'),

    resendLoading: false,
    refreshLoading: false,
}

export const getters = {
    resendLoading: function (state) {
        return !!state.resendLoading
    },
    refreshLoading: function (state) {
        return !!state.refreshLoading
    }
}

export const mutations = {
    'SET_REFRESH_LOADING': function (state, boolean = true) {
        state.refreshLoading = boolean;
    },

    'SET_RESEND_LOADING': function (state, boolean = true) {
        state.resendLoading = boolean;
    }
}
export const actions = {
    resend: function ({commit, state}, id) {
        commit('SET_RESEND_LOADING');

        return state.service.resend(id).then(response => {
            const model = Object.assign({}, response.data)
            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            commit('SET_RESEND_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    refresh: function ({commit, state}, id) {
        commit('SET_REFRESH_LOADING');

        return state.service.refresh(id).then(response => {
            const model = Object.assign({}, response.data)
            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            commit('SET_REFRESH_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    }
}
